import { render, staticRenderFns } from "./PreAccordionImage.vue?vue&type=template&id=2550fbc1&scoped=true&"
import script from "./PreAccordionImage.vue?vue&type=script&lang=js&"
export * from "./PreAccordionImage.vue?vue&type=script&lang=js&"
import style0 from "./PreAccordionImage.vue?vue&type=style&index=0&id=2550fbc1&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550fbc1",
  null
  
)

export default component.exports